import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';

import texts from '../texts.json';
import { StyledDplAutoComplete, DplOption } from './style';

export const dplOptionShape = PropTypes.shape({
  contractId: PropTypes.string,
  url: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
});

const optionLabel = (option) => option.label || option.url || '';

const resolveValue = (options, value) => (
  options.find((option) => option.contractId === value?.contractId) || value || null
);

const DplPicker = ({ options, value, onChange }) => (
  <StyledDplAutoComplete
    options={options}
    value={resolveValue(options, value)}
    onChange={(_, next) => onChange(next || null)}
    getOptionLabel={optionLabel}
    isOptionEqualToValue={(option, selected) => option.contractId === selected.contractId}
    renderOption={(props, option) => (
      <DplOption {...props} key={option.contractId}>
        {optionLabel(option)}
      </DplOption>
    )}
    renderInput={(params) => (
      <TextField
        {...params}
        placeholder={texts.sections.dpl.searchPlaceholder}
      />
    )}
    noOptionsText={texts.sections.dpl.noMatches}
    disableClearable
    autoHighlight
    fullWidth
  />
);

DplPicker.propTypes = {
  options: PropTypes.arrayOf(dplOptionShape).isRequired,
  value: dplOptionShape,
  onChange: PropTypes.func.isRequired,
};

DplPicker.defaultProps = {
  value: null,
};

export default DplPicker;
